




import Vue from "vue";
import Component from "vue-class-component";
import NodeOverviewScreen from "@/components/core/nodes/single-node/NodeOverview.vue";

@Component({
  components: {
    "node-overview": NodeOverviewScreen,
  },
})
export default class NodeOverviewView extends Vue {

}
